export const countFollow = (count: number) => {
  let returnString = count.toString();
  if (count < 1e3) returnString = count.toString();
  if (count >= 1e3 && count < 1e6) returnString = (count / 1e3).toFixed(1) + "K";
  if (count >= 1e6 && count < 1e9) returnString = (count / 1e6).toFixed(1) + "M";
  if (count >= 1e9 && count < 1e12) returnString = (count / 1e9).toFixed(1) + "B";
  if (count >= 1e12) returnString = (count / 1e12).toFixed(1) + "T";
  return returnString;
};
